import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RptloanpopupComponent } from "../../../shared/popup/rptloanpopup/rptloanpopup.component";

import { CommonmastersService } from "../../../../commonmasters/commonmasters.service";
import { PrintloansanctionService } from "../../../shared/print/printloansanction.service";

@Component({
  selector: 'app-rptloansanctionpopup',
  templateUrl: './rptloansanctionpopup.component.html',
  styleUrls: ['./rptloansanctionpopup.component.css']
})
export class RptloansanctionpopupComponent  implements OnInit {

  LoanTypeList: any[] = [];
  SchemeList: any[] = [];
  BranchList: any[] = [];
  CentreList: any[] = [];
  CategoryList: any[] = [];

  constructor(public dialogRef: MatDialogRef<RptloanpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private CommonmastersService: CommonmastersService,
    private printloansanctionService: PrintloansanctionService,) { }

  ngOnInit() {

    this.GetScheme()
    this.GetLoanType();
    this.GetBranch();
    this.GetCentre();
    this.GetCategory();

    this.data.LoanTypeId = 0;
    this.data.SchemeId = 0;
    this.data.LoanCategoryId = 0;
    this.data.BranchId = 0;
    this.data.CentreId = 0;
    this.data.StatusId = 0;
  }

  GenerateReports(): void {
    this.data.ReportName = "LoanSanctionReport";
    this.printloansanctionService.GenerateReport(this.data);
    this.dialogRef.close();
  }

  GetScheme() {
    this.CommonmastersService.FetchScheme().subscribe(data => {
      this.SchemeList = data;
    })
  }

  GetLoanType() {
    this.CommonmastersService.FetchLoanType().subscribe(data => {
      this.LoanTypeList = data;
    })
  }

  GetCategory() {
    this.CommonmastersService.GetCategoryList().subscribe(data => {
      this.CategoryList = data;
    })
  }

  GetBranch() {
    this.CommonmastersService.GetBranchList().subscribe(data => {
      this.BranchList = data;
      this.data.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    })
  }

  GetCentre() {
    this.CommonmastersService.FetchCenterList().subscribe(data => {
      this.CentreList = data;
    })
  }

}
